// extracted by mini-css-extract-plugin
export var activeNav = "Header-module--activeNav--fe2a1";
export var calltoAction = "Header-module--calltoAction--6a8ad";
export var logoPart = "Header-module--logoPart--807a4";
export var mainNav = "Header-module--main-nav--13a62";
export var sidePart = "Header-module--side-part--6ed4e";